<template>
	<div>
		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
                {{ $t("navbar.club") }}
            </h1>
		</div>
        <div class="bg-brown text-white">
    		<div class="container p-md-5 py-3">
    			<div class="row">
    				<div class="col-lg-8 col-md-8">
    			  		<p>{{ $t("association.intro_first") }}</p>
                        <p>{{ $t("association.intro_second") }}</p>
    				</div>
    				<div class="col-lg-4 col-md-4">
                        <img src="../assets/img/csodacsapat2.jpg" alt="" width="100%" draggable="false">
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-vanilla text-brown">
            <div class="container p-md-5 py-3">
                <div class="row">
                    <div class="col-lg-4 col-md-4 order-md-1 order-2">
                        <img src="../assets/img/csodacsapat.jpg" alt="" width="100%" draggable="false">
                    </div>
    				<div class="col-lg-8 col-md-8 order-md-2 order-1">
    					<p>{{ $t("association.intro_third") }}</p>
    					<p>{{ $t("association.intro_fourth") }}</p>
    				</div>
    			</div>
    		</div>
        </div>
	</div>
</template>

<script>
	import { Bus }  from "../bus.js";

    export default {
        data: function(){
            return {
                lang: ""
            }
        },
        created: function(){
            this.lang = this.$i18n.locale;
        },
        mounted: function(){
            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang === "hu"){
                    self.lang = "hu";
                }else{
                    self.lang = "en";
                }
            });
        },
        watch: {
            lang: function(){
                if(this.lang === "hu"){
                    history.pushState('', "Egyesület", "https://ijaszat.eu/egyesulet");
                }else{
                    history.pushState('', "Association", "https://ijaszat.eu/association");
                }
            }
        },
        metaInfo() {
            return {
                titleTemplate: chunk => (
                    this.lang === 'hu'
                    ? 'Csodaszarvas Íjászbarlang - Egyesület'
                    : 'Csodaszarvas Íjászbarlang - Association'
                ),
                meta: [
                {
                    vmid: 'description',
                    name: 'description',
                    content: this.lang === 'hu' ? 'Egyesületünk várja az újabb tagok jelentkezését, akik érdekel a versenyzés vagy csak maga a sport.' : 'Our association awaits its new members, archers who are interested in competing and this sport.',
                },
                {
                    vmid: 'og:description',
                    name: 'og:description',
                    content: this.lang === 'hu' ? 'Egyesületünk várja az újabb tagok jelentkezését, akik érdekel a versenyzés vagy csak maga a sport.' : 'Our association awaits its new members, archers who are interested in competing and this sport.',
                },
                {
                    vmid: 'og:title',
                    property: 'og:title',
                    content: this.lang === 'hu' ? 'Csodaszarvas Íjászbarlang - Egyesület' : 'Csodaszarvas Íjászbarlang - Association',
                }
            ]
            };
        }
    };
</script>


// WEBPACK FOOTER //
// src/components/Club.vue